import './Popper.scss'

const StylesComponents = ()=>{}

export default StylesComponents